import { render, staticRenderFns } from "./GenderComponent.vue?vue&type=template&id=b7286fea"
import script from "./GenderComponent.vue?vue&type=script&lang=ts"
export * from "./GenderComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports